export default "/images/st4.jpg?a2637572a9876100f65d2118b1472a06";